import io from 'socket.io-client'
import statsSetup from './stats'
import { sendEvent } from './events'
import liveUpdateAdsSetup from './liveAppUpdates'
import authSocketSetup from './auth'
import stripeSetup from './stripe'
import { useLocalBackend, localBackend } from '@/api/config/localBackend'

// const socket = io('http://localhost:5001')
const socket = useLocalBackend
  ? io(localBackend.origin, { path: localBackend.socketPath, transports: ['websocket'] })
  : io('https://notifications.foreplay.co')

statsSetup(socket)
liveUpdateAdsSetup(socket)
stripeSetup(socket)

export const authSocket = () => authSocketSetup(socket)
export const sendEventSocket = (event, payload) => sendEvent(socket, event, payload)
